import axios from "axios";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { ReactQueryKey } from "../../types";

export interface IResponseGetCheckAffiliated {
    valid: boolean,
    genVendorCode: string,
    tenant: string,
    dealer: string
}

export interface IGetCheckAffiliatedPayload {
    genVendorCode: string,
    tenant: string,
    dealer: string
}

export const getCheckAffiliated = async (params: IGetCheckAffiliatedPayload): Promise<IResponseGetCheckAffiliated> => {
    const response = await axios.get('/booking/instool/check-affiliated', {params});
    return response.data;
};

export const useCheckAffiliated = (
    params: IGetCheckAffiliatedPayload,
    options?: UseQueryOptions<IResponseGetCheckAffiliated | null>
) => {
    return useQuery<IResponseGetCheckAffiliated | null>(
        [ReactQueryKey.AffiliationCode, {tenant: params.tenant as string, dealer: params.dealer as string}],
        () => {
            if (
                !params || !params?.tenant || !params?.dealer
            ) {
                return null;
            }
            return getCheckAffiliated(params);
        },
        options
    )
};

export const useCheckAffiliatedQueryObserver = (params?: any) => {
    return useQuery<IResponseGetCheckAffiliated>({
        queryKey: [ReactQueryKey.AffiliationCode, {tenant: params?.tenant as string, dealer: params?.dealer as string}],
        enabled: false
    })
};
